<template>
  <v-app style="background: #fff">
    <v-main>
      <action-bar></action-bar>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

import ActionBar from '@/components/TheActionBar'
export default {
  components: {
    ActionBar
  },
  name: 'App',
  methods: {
    async setCurrentSite (site) {
      if (site.SiteId !== window.CONFIG.user.CurrentSiteId) {
        let siteChanged = await this.$store.dispatch(
          'global/setCurrentSiteId',
          { siteId: site.SiteId }
        )
        if (siteChanged) location.reload()
      }
    }
  },
  mounted () {
    //  NB! Hidden dependency. This expects jQuery ($) and Underscore (_) to be defined as global window variables.
    if (this.$route.hash) { window.$('#FixITOnlineSalongContent').css('display', 'block') } else if (this.$route.query.siteId) {
      // eslint-disable-next-line eqeqeq
      if (this.$route.query.siteId != window.CONFIG.user.CurrentSiteId) { this.setCurrentSite({ SiteId: this.$route.query.siteId }) } else {
        var newRouteQuery = window._.omit(this.$route.query, 'siteId')
        this.$router.replace({ query: newRouteQuery })
      }
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/app";
@import "toastr";
</style>
<style>
.truncate {
  padding-right: 5px;
}

html {
  font-size: 14px !important;
  overflow-y: auto !important;
}

.v-application--wrap {
  min-height: auto !important;
}

.container {
  padding: 0 !important;
}

.v-application {
  font-family: "Niveau Grotesk" !important;
}

#salong-landing-page .col-6 {
  flex: 0 0 50% !important;
  max-width: 50% !important;
}

#salong-landing-page .col-sm-4 {
  flex: 0 0 33.33333% !important;
  max-width: 33.33333% !important;
}

#salong-landing-page .col-md-3 {
  flex: 0 0 25% !important;
  max-width: 25% !important;
}

#salong-landing-page .col-xl-2 {
  flex: 0 0 16.66667% !important;
  max-width: 16.66667% !important;
}

@media (min-width: 768px) {
  @media (min-width: 768px) {
    .col-md-3 {
      flex: 0 0 25% !important;
    }
  }
}

@media (min-width: 1200px) {
  .col-xl-2 {
    flex: 0 0 16.66667% !important;
  }
}
</style>
